'use client'

import React, { useEffect, useState } from 'react'
import { useTranslations } from '@dustin-web/microsite-components/src/hooks'
import { constants } from '@dustin-web/microsite-config/src/constants'
import { useCookieState } from '@dustin-web/microsite-components/src/hooks/use-cookie-state'
import ButtonGroup, { ButtonGroupItemType } from '@dustin-web/microsite-components/src/button-group'
import { useProductListSettings } from '.'
import { ProductCardType } from './use-product-list-settings'

export const ProductListListType = () => {
  const { translate } = useTranslations()
  const { setCookie } = useCookieState()
  const { viewType } = useProductListSettings()
  const [activeId, setActiveId] = useState(viewType)
  const listTypesData: ButtonGroupItemType[] = [
    {
      id: 'gallery',
      title: translate('ViewType_Gallery'),
      icon: 'gallery',
    },
    {
      id: 'extended',
      title: translate('ViewType_Extended'),
      icon: 'list',
    },
  ]

  useEffect(() => {
    setCookie(constants.cookies.userSettings.viewType, activeId ?? false)
  }, [activeId])
  return (
    <ButtonGroup
      items={listTypesData}
      onClick={id => setActiveId(id as ProductCardType)}
      activeId={activeId ?? ''}
    />
  )
}
